import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function atLeastOneFieldRequiredValidator(fields: string[]): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const isAnyFieldFilled = fields.some(fieldName => {
      const control = formGroup.get(fieldName);
      return control && control.value && control.value.toString().trim() !== '';
    });

    return isAnyFieldFilled ? null : { atLeastOneRequired: true };
  };
}